<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <!--Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free-->
    <path
      d="m21.49 7.13-9-5a.99.99 0 0 0-.97 0l-9.01 5C2.19 7.31 2 7.64 2 8s.2.7.51.87l9 5c.15.08.32.13.49.13s.33-.04.49-.13l9-5c.32-.18.51-.51.51-.87s-.2-.7-.51-.87M12 11.86 5.06 8 12 4.14 18.94 8z"
    ></path>
    <path
      d="M12 18c.17 0 .33-.04.49-.13l9-5-.97-1.75-8.51 4.73-8.52-4.72-.97 1.75 9 5c.15.08.32.13.49.13Z"
    ></path>
    <path
      d="M11.51 21.87c.15.08.32.13.49.13s.33-.04.49-.13l9-5-.97-1.75-8.51 4.73-8.52-4.72-.97 1.75 9 5Z"
    ></path>
  </svg>
</template>
